import React from 'react';
import styled from 'styled-components';

import Button from '../Button';
import Icon from '../Icon';

function Pill({children, onDelete, ...props}) {
  return (
    <PillContainer>
      <PillButton {...props}>{children}</PillButton>
      {onDelete && <PillDelete onClick={onDelete}><Icon name="trash-2" /></PillDelete>}
    </PillContainer>
  );
}

const PillContainer = styled.div`
  height: 30px;
  margin-bottom: 3px;
  display: flex;
  border-radius: 0.25rem;
  overflow: hidden;
`;

const PillButton = styled(props => <Button blank block {...props} />)`
  padding: 0 0.375rem;
  background: #0049ee;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
`;

const PillDelete = styled(props => <Button blank block {...props} />)`
  background: #0036b0;
  padding: 2px 0.375rem 0 0.375rem;
  flex: 0;
  display: none;
  color: #fff;

  ${PillContainer}:hover & {
    display: block;
  }
`;

export default Pill;